/**
* PhaseEntity Interface
*
* Generated file, don't touch manually
*
* ModelVersion: 90001
*/

export { PhaseEntity } from "@archipad-js/archipad-model";
